import { useEffect, useState } from 'react';
import './ContrastModeToggle.css';
import { MdContrast } from 'react-icons/md';

export function ContrastModeToggle() {
  const [contrastMode, setContrastMode] = useState(false);

  useEffect(() => {
    if (document.body.classList.contains('contrastMode')) {
      setContrastMode(true);
    }
  }, []);

  const toggleContraste = () => {
    if (window.compensar && window.compensar.accesibilidadTextoContraste) {
      window.compensar.accesibilidadTextoContraste._controlador.cambiarContraste();
      setContrastMode(!contrastMode);
    }
  };

  return (
    <div className="contrast-mode-container">
      <div className="contrast-mode-text">
        <p>
          <strong>Accesibilidad:</strong> El alto contraste permite que las personas que tengan baja visión, puedan
          acceder al contenido fácilmente.
        </p>
      </div>
      <button
        type="button"
        className={`contrast-toggle-button ${contrastMode ? 'active' : ''}`}
        onClick={toggleContraste}
        aria-label="Alternar modo de alto contraste"
      >
        <MdContrast className="sun-icon" />
        <span className="button-text">Alto contraste</span> 
      </button>
    </div>
  );
}
